import { TypeRequest } from "../common/enums/AllEnums";
import { IForm, IFormQuestion, IFormRelated } from "../interfaces/IForm";
import { IResponse } from "../interfaces/IResponse";
import { BisApiRequest } from "./apis"

export const GetForms = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Formulario/ObtenerFormulariosByUsuario', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListTypeForm = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Formulario/ObtenerVisualizacionTipoFormulario', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetOptionsQuestionByQuery = (query: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerRespuestaOpcionesByQuery?query=${query}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetUpdateFrecuency = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Servicio/ObtenerFrecuenciaActualizaciones', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListTypeColumn = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Formulario/ObtenerFormularioDetalleColumnaTipo', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListTypeQuestion = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Formulario/ObtenerPreguntaTipo', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListTypeDetail = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Formulario/ObtenerFormularioDetalleTipo', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetListStatusForm = (): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest('/Formulario/ObtenerFormularioEstadoTipo', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetFormByID = (formID: number): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerFormularioByID?formularioID=${formID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}


export const DeactiveFormByID = (formID: number): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/DesactivarFormulario?formularioID=${formID}`, TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertForm = (form: IForm): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/InsertarFormulario `, TypeRequest.post, form).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const UpdateForm = (form: IForm): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ActualizarFormulario `, TypeRequest.put, form).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getFormsByListID = (listID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerFormularioListadosByListadoID?listadoID=${listID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getListByFormID = (formID: number): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerFormularioListadoByFormularioID?formularioID=${formID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const UpdateListByFormID = (formID: number, formRelatedList: IFormRelated[]): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ActualizarFormularioListado?formularioID=${formID}`, TypeRequest.put, formRelatedList).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getQuestionsByFormID = (formID: number): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ObtenerPreguntasByFormularioID?formularioID=${formID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const UpdateRelatedQuestionByFormID = (formID: number, questionRelatedList: IFormQuestion[]): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        BisApiRequest(`/Formulario/ActualizarPreguntaSiguienteID?formularioID=${formID}`, TypeRequest.put, questionRelatedList).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
